import React, { Component } from "react";
import { withStyles, Switch, InputLabel, FormControl, Input, FormHelperText, RadioGroup, Radio, FormControlLabel, Divider, DialogContent, InputAdornment, Button, IconButton, Icon, MenuItem, Card, TextField, Dialog, DialogActions, DialogTitle, Drawer, Avatar, Tooltip } from "@material-ui/core";
import { default as MaterialGrid } from '@material-ui/core/Grid';
import DropdownDefault from "../Layout/DropdownDefault";
import { Link } from "react-router-dom";
import CreateNewOpportunityDialog from "./CreateNewOpportunityDialog";
import OpportunityProfileFrame from "./OpportunityProfileFrame";
import moment from 'moment';//moment
import 'moment-timezone';//timezone
import AddNewPipeline from '../Settings/AddNewPipeline'
import { FilterComponent } from './FilterComponent'
import Autocomplete from '@material-ui/lab/Autocomplete'
import HiddenColumns from "../Common/HiddenColumns";
import Server from "../../Common/Server";

import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import {
    Grid,
    DragDropProvider,
    Table,
    TableHeaderRow,
    Toolbar,
    ColumnChooser,
    VirtualTable,
    TableSelection,
    TableColumnVisibility,
    SearchPanel,
    TableFixedColumns,
    TableColumnReordering,
    PagingPanel,
    TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import {
    SortingState,
    SearchState,
    IntegratedSorting,
    IntegratedFiltering,
    SelectionState,
    IntegratedSelection,
    PagingState,
    CustomPaging
} from '@devexpress/dx-react-grid';

import * as actions from '../../store/actions/index';
import { connect } from "react-redux";
import { compose } from 'redux';
import Snackbar from '@material-ui/core/Snackbar';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import LoadingState from "../Layout/LoadingState";
import InboxComposeMultipleDialog from "../CommonComposeMail/InboxComposeMultipleDialog";

let hiddneColumns = [];

const TooltipNew = withStyles((theme) => ({
    tooltip: {
      fontSize: 14,
    },
  }))(Tooltip);


const DefaultSizeOFtext = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    maxWidth: '52%',
    verticalAlign: 'middle',
    cursor: 'pointer'
}

class OpportunitiesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            switchView: true,
            drawerflag: false,
            searchText: '',
            deleteIds: [],
            currentPage: 0,
            pageSize: 10,
            column_name: "",
            sorttype: "",
            columns_array: [],
            fieldId: 40,
            isDeleteConfirmDialoOpen: false,
            defaultCurrentpage: 1,
            totalCount: 0,
            opportunityListData: [],
            updateColumnOrder: true,
            defaultColumnOrder: [],
            column_ids: [],
            isOpenedPipelines: false,
            isOpenedFilters: false,
            isOpenedFiltersDefault: false,
            isOpenedRange: false,
            shouldOpenCreateOpportunityDialog: false,
            FullCreateOpportunityDialog: false,
            minimizeOpportunityDialog: false,
            defaulSortingData: [
                { columnName: 'name', direction: 'asc' },
                { columnName: "primarycontact", direction: 'desc' },
                { columnName: "value", direction: 'desc' },
                { columnName: "stage", direction: 'desc' },
                { columnName: "source", direction: 'desc' },
                { columnName: "priority", direction: 'desc' },
                { columnName: 'visibility', direction: 'desc' },
                { columnName: 'company', direction: 'desc' },
                { columnName: 'owner', direction: 'desc' },
                { columnName: 'status', direction: 'desc' },
                { columnName: 'statusduration', direction: 'desc' },
                { columnName: 'statusupdatedate', direction: 'desc' },
                { columnName: 'lastcontacted', direction: 'desc' },
                { columnName: 'interactions', direction: 'desc' },
                { columnName: 'inactivedays', direction: 'desc' },
                { columnName: 'dayinstage', direction: 'desc' },
            ],
            selection: [],
            leadLogs: [],
            filterObject: {},
            systemTagsList: [],
            systemCityListArray: [],
            systemStateListArray: [],
            systemZipcodeListArray: [],
            countryListArray: [],
            fieldDisplay: [],
            filterRangeArray: [],
            dropdownhide: [],
            filterSaveDialoge: false,
            fitertype: "1",
            filtername: "",
            recordtypeid: 4,
            filternameError: false,
            opportunityFilterListArray: [],
            displaySelectedFilterName: "All Opportunity",
            filterUpdateId: "",
            allowStateUpdateFilter: true,
            filterdata: [],
            activityquery: "any",
            tagsquery: "any",
            dateformat: 'MM/DD/YYYY',
            timeZone: 'America/New_York',
            usersListArray: [],
            AllOpportunityFilterKey: "",
            columnWidths: [
                { columnName: "name", width: 250 },
                { columnName: "primarycontact", width: 180 },
                { columnName: "value", width: 180 },
                { columnName: "stage", width: 180 },
                { columnName: "source", width: 180 },
                { columnName: "priority", width: 180 },
                { columnName: "company", width: 180 },
                { columnName: "owner", width: 180 },
                { columnName: "status", width: 180 },
                { columnName: "visibility", width: 180 },
                { columnName: "statusduration", width: 120 },
                { columnName: "statusupdatedate", width: 180 },
                { columnName: "lastcontacted", width: 180 },
                { columnName: "interactions", width: 180 },
                { columnName: "inactivedays", width: 180 },
                { columnName: "dayinstage", width: 180 },
            ],
            isDataLoading: true,
            newSavedFilterName: "",
            /*START For Add Pipeline Dialog*/
            shouldOpenNewPipelineDialog: false,
            FullNewPipelineDialog: false,
            minimizePipelineDialog: false,
            isLoadingPipelineList: true,
            selectedPipelineId: 1,
            isLoadingPipelineList: true,
            pipelineListArray: [],
            /*END For Add Pipeline Dialog*/
            masterActivityTypesList: [],
            defaultHiddenColumnNames: [],
            hasRingCentralConnect: false,
            itegrationDetails: [],
            crudPermission: {
                iscreate: true,
                isdelete: true,
            },
            disableID: "0",
            SelectedComapnyID: [],
            Companydata: [],
            relatedemails : [],
            userSelectedBlukEmail: [],
            isOpenedReplayBulkEmail: false,
            allSettings: "",
            IsSizeDefault : true,
        };
    }
    getUserPermission = () => {
        if (this.props.settingReducer.userPermissionDetails.data) {
            let udata = this.props.settingReducer.userPermissionDetails.data.data
            if (udata.visibilityaccess.length > 0 &&
                udata.teampermissionstatus === true &&
                this.props.authReducer.userRole.id === 3) {
                var pipelineId = localStorage.getItem('selected_pipeline_id')
                let crudPermission = udata.visibilityaccess.find(function (e) { return e.piplineid === parseInt(pipelineId) });
                this.setState({
                    crudPermission: crudPermission,
                    selectedPipelineId: pipelineId,
                })
            }
        }
    }
    componentDidMount() {
        let userData = JSON.parse(localStorage.getItem('user_data_session'))
        let userprefparams = { userid: userData.id }
        this.props.getActivityTypes(this.props.apolloClient.client);
        this.props.getUserSetting(this.props.apolloClient.client, userprefparams);
        this.props.getCityList(this.props.apolloClient.client);
        this.props.getFilterListOpportunity(this.props.apolloClient.client, 4);
        this.props.getStateList(this.props.apolloClient.client);
        this.props.getZipcodeList(this.props.apolloClient.client);
        this.props.getUserList(this.props.apolloClient.client);
        this.props.getUserIntegration(this.props.apolloClient.client);
        this.props.generateMailBoxId(this.props.apolloClient.client);
        this.props.getEmailSetting(this.props.apolloClient.client);
        var pipelineId = this.state.selectedPipelineId;
        if (localStorage.getItem('selected_pipeline_id')) {
            pipelineId = localStorage.getItem('selected_pipeline_id')
        } else {
            localStorage.setItem('selected_pipeline_id', this.state.selectedPipelineId)
            pipelineId = localStorage.getItem('selected_pipeline_id')
        }
        let val = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(pipelineId),
            filterid: 1,
        }
        if (localStorage.getItem('selected_pipeline_id')) {
            this.getListing(val)
        }
        this.props.getPipelines(this.props.apolloClient.client);
        // let params_customfield = { typeId:1 }
        // this.props.customFieldList(this.props.apolloClient.client, params_customfield);

    }
    getListing = (val) => {
        this.props.getOpportunitiesFilterList(this.props.apolloClient.client, val);
        this.props.getOpportunitiesListColumnOrder(this.props.apolloClient.client);
    }

    componentWillReceiveProps(props) {
        this.getUserPermission()

        if (props.settingReducer.generatedmailboxid.data) {
            let mailboxid = props.settingReducer.generatedmailboxid.data.mailboxid;
            this.setState({ mailboxid });
        }

        if (props.settingReducer.emailsettings.data) {
            const mian_data = props.settingReducer.emailsettings.data
            this.setState({
                allSettings: mian_data,
            })
        }

        if (props.settingReducer.getcontactRelatedData) {
            if (props.settingReducer.getcontactRelatedData.data && props.settingReducer.getcontactRelatedData.data.data) {
                let Companydata = props.settingReducer.getcontactRelatedData.data.data;
                let emails = [];
                if (Companydata && Companydata !== this.state.Companydata) {
                    Companydata.map((item) => {
                        if (item.__contactdetail__.length > 0) {
                            item.__contactdetail__.map((data) => {
                                if (data.__field__.id == "21" && data.values.length > 0) {//email
                                    emails.push(data.values[0].value);
                                    this.setState({ isDataLoading: false });
                                }
                            })
                        }
                    });
                    this.setState({
                        relatedemails: emails,
                        Companydata: Companydata,
                    });
                }
            }
        }

        if (props.settingReducer.masterActivityTypesList && props.settingReducer.masterActivityTypesList.is_loaded == true && props.settingReducer.masterActivityTypesList.data) {
            props.settingReducer.masterActivityTypesList.is_loaded = false
            var dataList = props.settingReducer.masterActivityTypesList.data;
            var count = dataList.filter(function (element) {
                if (element.is_disable == true) {
                    return element
                }
            });
            this.setState({
                masterActivityTypesList: dataList,
            });
        }
        if (props.settingReducer.userItegration.data && props.settingReducer.userItegration.data !== this.state.itegrationDetails) {
            let data = props.settingReducer.userItegration.data;
            let hasRingCentralConnect = false;
            data.map((item) => {
                if (item.status && item.integrationid == 10) {
                    hasRingCentralConnect = true;
                    if (window.RCAdapter) {
                        window.RCAdapter.setClosed(true);
                    }
                }
            });
            this.setState({
                itegrationDetails: data,
                hasRingCentralConnect: hasRingCentralConnect,
            });
        }
        if (props.opportunityReducer.opportunityList.data && props.opportunityReducer.opportunityList.is_loaded) {
            let oppoList = props.opportunityReducer.opportunityList.data;

            //Pipelines list array
            if (props.settingReducer.pipelineListArray.data && props.settingReducer.pipelineListArray.is_loaded) {
                var pipeData = props.settingReducer.pipelineListArray.data
                //Apply pipeline id to localstorage
                var selectedPipelineId = localStorage.getItem('selected_pipeline_id');
                if (!selectedPipelineId) {
                    localStorage.setItem('selected_pipeline_id', "1");
                } else {
                    selectedPipelineId = localStorage.getItem('selected_pipeline_id');
                }
                selectedPipelineId = localStorage.getItem('selected_pipeline_id');
                let allData = pipeData;
                if (props.settingReducer.userPermissionDetails.data) {
                    let udata = props.settingReducer.userPermissionDetails.data.data
                    if (udata.visibilityaccess.length > 0 &&
                        udata.teampermissionstatus === true &&
                        props.authReducer.userRole.id === 3) {
                        allData = [];
                        pipeData.map((val, k) => {
                            let dt = udata.visibilityaccess.find(function (e) { return e.piplineid === parseInt(val.id) });
                            if (dt && dt.isaccess) {
                                localStorage.setItem('selected_pipeline_id', val.id);
                                this.setState({ selectedPipelineId: val.id })
                                allData.push(val)
                            }
                        })
                    }
                }
                this.setState({
                    pipelineListArray: allData,
                    isLoadingPipelineList: false,
                    selectedPipelineId: selectedPipelineId,
                    //isDataLoading: false,
                }, () => {
                    this.forceUpdate()
                    props.settingReducer.pipelineListArray.is_loaded = false
                })
            }

        }
        if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
            const usersListArray = props.settingReducer.usersListArray.data;
            this.setState({ usersListArray: usersListArray })
        }
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;

            let format = usersetting.dateformat;
            let timezone = usersetting.timezone;

            this.setState({ dateformat: format, timeZone: timezone })
        }

        if (props.opportunityReducer.opportunityFilterListArray.data && this.state.allowStateUpdateFilter || props.opportunityReducer.opportunityFilterListArray.is_loaded) {
            const opportunityFilterListArray = props.opportunityReducer.opportunityFilterListArray.data;
            props.opportunityReducer.opportunityFilterListArray.is_loaded = false
            this.setState({ opportunityFilterListArray: opportunityFilterListArray, allowStateUpdateFilter: false })

            var AllfilterIdKey = this.findWithAttr(opportunityFilterListArray, 'id', "11");
            if (AllfilterIdKey != -1) {
                this.setState({ AllOpportunityFilterKey: AllfilterIdKey })
            }


            //Aplying default filter selected  STRAT

            let defaultFilter;
            //checkdefault filter  in localStorage
            var localStorageFilterId = localStorage.getItem('selected_opportunity_filter_id');

            if (localStorageFilterId) {
                var localId = this.findWithAttr(opportunityFilterListArray, 'id', localStorageFilterId);
                defaultFilter = opportunityFilterListArray[localId];
            } else {
                var defaultKeyStatus = this.findWithAttr(opportunityFilterListArray, 'id', "11");
                defaultFilter = opportunityFilterListArray[defaultKeyStatus];
                localStorage.setItem('selected_opportunity_filter_id', defaultFilter.id);
            }

            //my open oppoertunity
            if (defaultFilter.id == "12") {
                let udata = JSON.parse(localStorage.getItem('user_data_session'))
                defaultFilter.filteroption = [
                    {
                        fieldid: "46", name: "owner", type: "value", value: [udata.email]
                    },
                    {
                        fieldid: "45", name: "status", type: "value", value: ["Open"]
                    }
                ]
            }

            //Opportunities Im Following
            if (defaultFilter.id == "14") {
                defaultFilter.filteroption = [
                    {
                        fieldid: "0",
                        name: "followed",
                        type: "followed",
                        value: [true],
                        chktype: "follow",
                    }
                ]
            }

            //won opportunity
            if (defaultFilter.id == "15") {
                let udata = JSON.parse(localStorage.getItem('user_data_session'))
                defaultFilter.filteroption = [
                    {
                        fieldid: "45", name: "status", type: "value", value: ["Won"]
                    }
                ]
            }
            //Open opportunity
            if (defaultFilter.id == "13") {
                let udata = JSON.parse(localStorage.getItem('user_data_session'))
                defaultFilter.filteroption = [
                    {
                        fieldid: "45", name: "status", type: "value", value: ["Open"]
                    }
                ]
            }

            //updateFilter name to display and menudisplay array set
            this.setState({
                displaySelectedFilterName: this.state.newSavedFilterName ? this.state.newSavedFilterName : defaultFilter.filtername,
                fieldDisplay: [],
                dropdownhide: [],
            })

            if (defaultFilter.filteroption.length > 0) {
                let filterObject = this.state.filterObject;
                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    defaultFilter.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }

                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }
                        if (val.type === "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }
                        if (val.name == "zipcode" || val.name == "city" || val.name == "state" || val.name == "country") {//hideshow ENABLE state/city/country/state
                            dropdownhideShow.push(val.name)
                        } else {
                            dropdownhideShow.push(val.name)
                        }
                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                        newSavedFilterName: "",
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    if (localStorage.getItem('selected_pipeline_id')) {
                        this.setState({
                            selectedPipelineId: localStorage.getItem('selected_pipeline_id'),
                        }, () => this.forceUpdate())
                    }
                    this.handleFilterSubmit();
                });
            }
            //Aplying default filter selected  END
        }

        if (props.opportunityReducer.opportunityLogList && props.opportunityReducer.opportunityLogList.data && props.opportunityReducer.opportunityLogList.data.logdata) {
            this.setState({ opportunityLogs: props.opportunityReducer.opportunityLogList.data.logdata })
        }

        if (props.settingReducer.opportunitiesCustomFieldList.data) {
            const customFields = props.settingReducer.opportunitiesCustomFieldList.data;
            this.setState({ fieldsList: customFields })
        }
        if (props.settingReducer.systemCityListArray && props.settingReducer.systemCityListArray.data && this.state.systemCityListArray.length == 0) {
            this.setState({ systemCityListArray: props.settingReducer.systemCityListArray.data })
        }
        if (props.settingReducer.systemZipcodeListArray && props.settingReducer.systemZipcodeListArray.data && this.state.systemZipcodeListArray.length == 0) {
            this.setState({ systemZipcodeListArray: props.settingReducer.systemZipcodeListArray.data })
        }
        if (props.settingReducer.systemStateListArray && props.settingReducer.systemStateListArray.data && this.state.systemStateListArray.length == 0) {
            this.setState({ systemStateListArray: props.settingReducer.systemStateListArray.data })
        }
        if (props.settingReducer.countryListGql.data && this.state.countryListArray.length == 0) {
            const countryies = props.settingReducer.countryListGql.data;
            this.setState({ countryListArray: countryies })
        }

        if (props.settingReducer.systemTagsList.data && this.state.systemTagsList.length == 0) {
            const tagsData = props.settingReducer.systemTagsList.data;
            this.setState({ systemTagsList: tagsData })
        }

        if (props.opportunityReducer.opportunityFieldData.data && props.opportunityReducer.opportunityFieldData.is_loaded) {
            this.setState({
                //isDataLoading:false,
            }, () => this.forceUpdate())
        }


        // if(props.opportunityReducer.opportunityListOrder.data != undefined)
        // {
        //     console.log(props.opportunityReducer.opportunityListOrder.data);
        //     let order_wise_column = [];
        //     props.opportunityReducer.opportunityListOrder.data.map((orderData)=>{
        //         //order_wise_column[orderData.orderno] 


        //     });
        // }
        if (props.settingReducer.opportunitiesCustomFieldList.data) {
            let column_ids = this.state.column_ids;
            let columns_array = this.state.columns_array;
            let columnWidths = this.state.columnWidths;
            let defaultColumnOrder = this.state.defaultColumnOrder;
            let defaulSortingData = this.state.defaulSortingData;

            const customFields = props.settingReducer.opportunitiesCustomFieldList.data;

            customFields.map((field) => {
                if (field && (field.isdiactivated || field.is_default)) {
                    column_ids[field.fieldkey] = parseFloat(field.id);
                    if (this.findWithAttr(columns_array, 'name', field.fieldkey) == -1) {

                        // creating dynamic columns for table ------------------------
                        columns_array.push({ name: field.fieldkey, title: field.fieldlabel });
                        if (field.fieldkey != 'name')
                            defaultColumnOrder.push(field.fieldkey);

                        if (field.fieldkey == 'name') {
                            columnWidths.push(
                                { columnName: "name", width: 250 },
                            );
                        } else {
                            columnWidths.push(
                                { columnName: field.fieldkey, width: 180 },
                            );
                        }
                    }
                }
            });
            if (this.findWithAttr(columns_array, 'name', 'statusupdatedate') == -1) {
                columns_array.push({ name: 'statusupdatedate', title: 'Status updatedate' });
                columnWidths.push({ columnName: 'statusupdatedate', width: 180 });
                defaultColumnOrder.push('statusupdatedate');
            }
            if (this.findWithAttr(columns_array, 'name', 'statusduration') == -1) {
                columns_array.push({ name: 'statusduration', title: 'Status Duration' })
                columnWidths.push({ columnName: 'statusduration', width: 180 });
                defaultColumnOrder.push('statusduration');
            }
            if (this.findWithAttr(columns_array, 'name', 'lastcontacted') == -1) {
                columns_array.push({ name: 'lastcontacted', title: 'Last Contacted' })
                columnWidths.push({ columnName: 'lastcontacted', width: 180 });
                defaultColumnOrder.push('lastcontacted');
            }
            if (this.findWithAttr(columns_array, 'name', 'interactions') == -1) {
                columns_array.push({ name: 'interactions', title: 'Interactions' })
                columnWidths.push({ columnName: 'interactions', width: 180 });
                defaultColumnOrder.push('interactions');
            }
            if (this.findWithAttr(columns_array, 'name', 'inactivedays') == -1) {
                columns_array.push({ name: 'inactivedays', title: 'Inactive Days' })
                columnWidths.push({ columnName: 'inactivedays', width: 180 });
                defaultColumnOrder.push('inactivedays');
            }
            if (this.findWithAttr(columns_array, 'name', 'dayinstage') == -1) {
                columns_array.push({ name: 'dayinstage', title: 'Days In Stage' })
                columnWidths.push({ columnName: 'dayinstage', width: 180 });
                defaultColumnOrder.push('dayinstage');
            }


            this.setState({ column_ids: column_ids, columnWidths: columnWidths, columns_array: columns_array, defaultColumnOrder: defaultColumnOrder, }, () => this.forceUpdate());

            if (this.state.drawerflag) {
                setTimeout(() => {
                    this.setState({ drawerOpen: true, drawerflag: false }, () => this.forceUpdate())
                }, 500);
            }


            if (props.opportunityReducer.opportunityListOrder &&
                props.opportunityReducer.opportunityListOrder.data &&
                props.opportunityReducer.opportunityListOrder.data.length > 0) {
                let ordernoList = [];
                let list = [];
                let newcolumn_arr = [];
                let hidddenCol = ['lastname'];
                props.opportunityReducer.opportunityListOrder.data.map((listOrder) => {
                    if (listOrder.field) {
                        if (listOrder.field.fieldkey != "name") {
                            if (listOrder.isactive == false)
                                hidddenCol.push(listOrder.field.fieldkey);

                            ordernoList.push(listOrder.field.fieldkey);
                        }

                        if (this.state.columns_array) {
                            let key_col = this.findWithAttr(this.state.columns_array, 'name', listOrder.field.fieldkey);
                            newcolumn_arr.push(this.state.columns_array[key_col]);
                        }
                    } else {
                        let temp_order = props.opportunityReducer.opportunity_column_order_extra[0];
                        let oppcol = Object.keys(temp_order).find(key => temp_order[key] == listOrder.columnid);

                        if (listOrder.isactive == false)
                            hidddenCol.push(oppcol);

                        ordernoList.push(oppcol)
                        if (this.state.columns_array) {
                            let key_col = this.findWithAttr(this.state.columns_array, 'name', oppcol);
                            newcolumn_arr.push(this.state.columns_array[key_col]);
                        }
                    }
                });
                this.setState({ columns_array: newcolumn_arr });

                if (this.state.updateColumnOrder)
                    this.setState({ defaultColumnOrder: ordernoList, defaultHiddenColumnNames: hidddenCol }, () => this.forceUpdate());
            }
        }
        if (props.opportunityReducer.opportunityList.data && props.opportunityReducer.opportunityList.data.data) {
            let totalRecord = props.opportunityReducer.opportunityList.data.totalrecord;
            this.setState({ totalCount: totalRecord });
            let listrows = [];
            let columns_array = this.state.columns_array;
            // // for displaying table rows dynamically-------------------
            props.opportunityReducer.opportunityList.data.data.map((opportunitydata, oppindex) => {
                let row_str = [];
                let thisVar = this;
                Object.keys(opportunitydata).forEach(function (key) {
                    columns_array.map((colm) => {
                        if (!row_str[colm.name]) {
                            if (colm.name == "name") {//name field
                                let star_icon = opportunitydata['isfavourite'] ? "star" : "star_border";
                                let color_class = (opportunitydata[colm.name]) ? opportunitydata[colm.name].charAt(0).toLowerCase() : "";
                                let data = '-';
                                data = (
                                    <div className="white_space_nowrap">
                                        <Avatar className={"avatar_circle color_"}>{"$"}</Avatar>
                                        <span className="font-weight-500 hover_name" style={DefaultSizeOFtext} >
                                            <Link to={"/opportunities/opportunities/" + opportunitydata['opportunities_id']}>{opportunitydata[colm.name]}</Link>
                                        </span>
                                        <IconButton className={'text-secondary ml-4' + ' ' + (star_icon == 'star' ? 'visibleStarIcon' : '')} onClick={(lead, status) => thisVar.handleFavorite(opportunitydata['opportunities_id'], opportunitydata['isfavourite'])} size="small">
                                            <Icon>{star_icon}</Icon>
                                        </IconButton>
                                        <IconButton size="small" className="user_info ml-4" color="primary" onClick={(e) => thisVar.handleDrawerRight(opportunitydata['opportunities_id'])}>
                                            <Icon>remove_red_eye</Icon>
                                        </IconButton>
                                    </div>);

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            else if (colm.name == "value") {//Value fiels
                                let value = '-';
                                if (opportunitydata[colm.name]) {
                                    opportunitydata[colm.name].map((statusdata) => (
                                        value = (statusdata.srno == 1) ? statusdata.value : null
                                    ))
                                }
                                if (!row_str[colm.name])
                                    row_str[colm.name] = value;
                            } else if (colm.name == "websites" || colm.name == "social" || colm.name == "phones" || colm.name == "email" || colm.name == "status" || colm.name == "source" || colm.name == "visibility" || colm.name == "tags" || colm.name == "pipeline" || colm.name == "priority" || colm.name == "stage") {
                                let data = '-';
                                let hasRingCentralConnect = thisVar.state.hasRingCentralConnect;
                                if (opportunitydata[colm.name]) {

                                    if (colm.name == "websites") {
                                        opportunitydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? <a href={statusdata.value} className="text_link">{statusdata.value}</a> : null
                                        ))
                                    }
                                    if (colm.name == "phones") {
                                        opportunitydata[colm.name].map((statusdata) => {
                                            if (parseInt(statusdata.srno) == 1) {
                                                data = hasRingCentralConnect === true ?
                                                    <a href={"tel:" + statusdata.value} className="text_link">{statusdata.value}</a> : statusdata.value;
                                            }
                                        })
                                    }
                                    if (colm.name == "social" || colm.name == "status" || colm.name == "source" || colm.name == "visibility" || colm.name == "pipeline" || colm.name == "priority" || colm.name == "stage") {
                                        opportunitydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? statusdata.value : null
                                        ))
                                    }
                                    if (colm.name == "tags") {
                                        let tag = [];
                                        opportunitydata[colm.name].map((statusdata) => {
                                            statusdata.value && tag.push(statusdata.value)
                                        })

                                        data = (tag.toString()) ? tag.toString() : null
                                    }
                                }
                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }

                            else if (colm.name == "owner") {
                                let data = '-';
                                if (opportunitydata[colm.name]) {
                                    if (typeof (opportunitydata[colm.name]) == "string") {
                                        data = opportunitydata[colm.name];
                                    }
                                    else {
                                        opportunitydata[colm.name].map((statusdata) => (
                                            data = (statusdata.srno == 1) ? statusdata.name : null
                                        ))
                                    }
                                }
                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            // { statusupdatedate: 1001, statusduration: 1002, lastcontacted: 1003, interactions: 1004, inactivedays: 1005 }
                            else if (colm.name == "statusupdatedate" || colm.name == "lastcontacted") {
                                let data = '-';
                                data = opportunitydata[colm.name] ?
                                    moment.unix(opportunitydata[colm.name]).tz(thisVar.state.timeZone).format(thisVar.state.dateformat)
                                    : '-';
                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            else if (colm.name == "statusduration" || colm.name == "interactions" || colm.name == "inactivedays" || colm.name == "dayinstage") {
                                let data = '-';
                                data = opportunitydata[colm.name] ? opportunitydata[colm.name] : '-';

                                if (!row_str[colm.name])
                                    row_str[colm.name] = data;
                            }
                            else {
                                let data = '-'
                                if (thisVar.state.fieldsList) {
                                    if (opportunitydata[colm.name]) {
                                        var key = thisVar.findWithAttr(thisVar.state.fieldsList, 'fieldkey', colm.name);
                                        if (key != -1) {
                                            if (thisVar.state.fieldsList[key].is_default == false && (thisVar.state.fieldsList[key].fieldtype.id == "4")) {
                                                opportunitydata[colm.name].map((statusdata) => (
                                                    data = (statusdata.srno == 1) ? statusdata.value : null
                                                ))
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "5") {
                                                let maindata = [];
                                                opportunitydata[colm.name].map((statusdata) => {
                                                    statusdata.value && maindata.push(statusdata.value)
                                                })
                                                data = (maindata.toString()) ? maindata.toString() : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "1" || thisVar.state.fieldsList[key].fieldtype.id == "2") {
                                                let data = '-';
                                                if (opportunitydata[colm.name]) {
                                                    if (typeof (opportunitydata[colm.name]) == "string") {
                                                        data = opportunitydata[colm.name];
                                                    }
                                                    else {
                                                        opportunitydata[colm.name].map((statusdata) => (
                                                            data = (statusdata.srno == 1) ? statusdata.value : null
                                                        ))
                                                    }
                                                }
                                                if (!row_str[colm.name])
                                                    row_str[colm.name] = data;
                                                // data = opportunitydata[colm.name] ? opportunitydata[colm.name] : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "6") {//
                                                data = opportunitydata[colm.name]
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "7") {//date field
                                                data = opportunitydata[colm.name] + "%"
                                            }
                                            // //validating date fields
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "8") {//date field
                                                //data = moment.unix(opportunitydata[colm.name]).tz(thisVar.state.timeZone).format(thisVar.state.dateformat)
                                                data = moment(opportunitydata[colm.name]).format(thisVar.state.dateformat)
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "9") {
                                                data = opportunitydata[colm.name] ?
                                                    <a href={opportunitydata[colm.name]} className="text_link">{opportunitydata[colm.name]}</a>
                                                    : null
                                            }
                                            if (thisVar.state.fieldsList[key].fieldtype.id == "10") {
                                                data = opportunitydata[colm.name]
                                            }
                                            if (!row_str[colm.name])
                                                row_str[colm.name] = data;
                                        }
                                    }
                                }
                            }
                        }
                    });
                });
                let row_str_data = Object.assign({}, row_str);
                listrows.push(row_str_data)
                row_str = [];
            });

            this.setState({
                isDataLoading: false,
            }, () => this.forceUpdate())
            this.setState({ opportunityListData: listrows }, () => this.forceUpdate());
        }
        else {
            let listrows = [];
            this.setState({
                opportunityListData: listrows,
            }, () => {
                this.forceUpdate()

                setTimeout(() => {
                    this.setState({
                        isDataLoading: false,
                    })
                }, 3000);
            })
        }

    }

    onColumnWidthsChange = (widths) => {
        // console.log(widths, 'widthswidthswidths');
        let IsSizeDefault;

        widths.map((NameSize) => { 
            if(NameSize.columnName === 'name' && NameSize.width !== 250 ){
                IsSizeDefault = false;
            }
         });

        // console.log("IsSizeDefault", IsSizeDefault);
        this.setState({ IsSizeDefault : IsSizeDefault });
    }

    handleChange = (event) => {
        if (event.target.name === 'switchView') {
            let path = `/opportunities/opportunities-card`;
            this.props.history.push(path);
        }
        if (event.target.type === 'checkbox') {
            this.setState({ [event.target.name]: event.target.checked });
        } else {
            this.setState({ [event.target.name]: event.target.value });
        }
    }
    handleChangeColumnOrder = (val) => {

        let arr_ids = [];
        let arr_orders = [];
        let arr_status = [];
        let columns = [];
        let hiddens = this.state.defaultHiddenColumnNames;

        val.map((col, key) => {
            if (col == 'statusupdatedate' || col == 'statusduration' || col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted' || col == 'dayinstage') {
                if (this.props.opportunityReducer.opportunity_column_order_extra[0][col] != null) {
                    arr_ids.push(this.props.opportunityReducer.opportunity_column_order_extra[0][col])
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
            else {
                if (this.state.column_ids[col] != null) {
                    arr_ids.push(this.state.column_ids[col]);
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
        });

        this.setState({ updateColumnOrder: false, defaultColumnOrder: columns });
        let changeColumnOrderparams = {
            fieldid: arr_ids,
            columnstatus: arr_status,
            orderno: arr_orders
        };


        this.props.updateOpportunitiesListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);

    }

    // handleChangeColumnHidden = (val) => {
    //     let arr_ids = [];
    //     let arr_orders = [];
    //     let arr_status = [];
    //     let columns = [];
    //     const colsOrder = this.state.defaultColumnOrder;

    //     colsOrder.map((col, key) => {
    //         if (col == 'statusupdatedate' || col == 'statusduration' || col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted' || col == 'dayinstage') {
    //             if (this.props.opportunityReducer.opportunity_column_order_extra[0][col] != null) {
    //                 arr_ids.push(this.props.opportunityReducer.opportunity_column_order_extra[0][col])
    //                 arr_orders.push(key + 1);
    //                 columns.push(col);

    //                 if (val.indexOf(col) == -1)
    //                     arr_status.push(true)
    //                 else
    //                     arr_status.push(false)
    //             }
    //         }
    //         else {
    //             if (this.state.column_ids[col] != null) {
    //                 arr_ids.push(this.state.column_ids[col]);
    //                 arr_orders.push(key + 1);
    //                 columns.push(col);

    //                 if (val.indexOf(col) == -1)
    //                     arr_status.push(true)
    //                 else
    //                     arr_status.push(false)
    //             }
    //         }
    //     });


    //     let changeColumnOrderparams = {
    //         fieldid: arr_ids,
    //         columnstatus: arr_status,
    //         orderno: arr_orders
    //     };

    //     this.setState({ updateColumnOrder: false, defaultHiddenColumnNames: val });
    //     this.props.updateOpportunitiesListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);
    // }

    handleChangeColumnHidden = (val) => {
        hiddneColumns = val;
        this.setState({ defaultHiddenColumnNames: hiddneColumns });
    }
    handleHiddensMain = (hiddens) => {
        // console.log(hiddens, 'hiddens');

        let arr_ids = [];
        let arr_orders = [];
        let arr_status = [];
        let columns = [];
        hiddneColumns = hiddens;
        let colsOrder = this.state.defaultColumnOrder;

        colsOrder.map((col, key) => {

            if (col == 'statusupdatedate' || col == 'statusduration' || col == 'interactions' || col == 'inactivedays' || col == 'lastcontacted') {
                if (this.props.opportunityReducer.opportunity_column_order_extra[0][col] != null) {
                    arr_ids.push(this.props.opportunityReducer.opportunity_column_order_extra[0][col])
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
            else {
                if (this.state.column_ids[col] != null) {
                    arr_ids.push(this.state.column_ids[col]);
                    arr_orders.push(key + 1);
                    columns.push(col);

                    if (hiddens.indexOf(col) == -1)
                        arr_status.push(true)
                    else
                        arr_status.push(false)
                }
            }
        });

        let changeColumnOrderparams = {
            fieldid: arr_ids,
            columnstatus: arr_status,
            orderno: arr_orders
        };

        this.setState({ updateColumnOrder: false, defaultHiddenColumnNames: hiddneColumns });
        this.props.updateOpportunitiesListColumnOrder(this.props.apolloClient.client, changeColumnOrderparams);
    }

    handleFavorite = (opportunity, status) => {
        let setFavoriteParams = [];
        setFavoriteParams['favorite'] = { status: !status, opportunitiesid: opportunity };
        setFavoriteParams['listval'] = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: this.state.currentPage + 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(this.state.selectedPipelineId),
            filterid: 1
        };


        this.props.addFavouriteOpportunities(this.props.apolloClient.client, setFavoriteParams);
    }

    handleCurrentPage = (page) => {
        this.setState({
            currentPage: page,
            selection: [],
        })

        let params_for_pagechange = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: page + 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(this.state.selectedPipelineId),
            filterid: 1
        }
        this.getListing(params_for_pagechange);
    }
    handlePageSize = (size) => {

        this.setState({
            pageSize: size,
            currentPage: 0,
            selection: [],
        })

        let params_for_pagesize = {
            filterdata: this.state.filterdata,
            list: {
                limit: size,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(this.state.selectedPipelineId),
            filterid: 1
        }
        this.getListing(params_for_pagesize);
    }

    toggleLeadList = () => {
        this.setState(oldStateLeadList => ({ isOpenedPipelines: !oldStateLeadList.isOpenedPipelines }));
    }

    toggleFiltersDefault = () => {
        this.setState(oldStateLeadList => ({ isOpenedFiltersDefault: !oldStateLeadList.isOpenedFiltersDefault }));
    }

    toggleCustomFilters = () => {
        this.setState(oldStateCustomFilters => ({ isOpenedFilters: !oldStateCustomFilters.isOpenedFilters }));
    }

    toggleRange = (e) => {
        e.preventDefault();
        this.setState(oldStateRange => ({ isOpenedRange: !oldStateRange.isOpenedRange }));
    }
    changeDefaultSorting = (val) => {
        let column = val[0].columnName;
        let direction = val[0].direction;

        let data = this.state.defaulSortingData;
        data = data.filter(sort => sort.columnName !== val[0].columnName).map(sort => {
            sort.direction = "desc"
            return sort;
        })
        data.push(val[0]);
        this.setState({
            defaulSortingData: data,
            sorttype: direction
        }, () => this.forceUpdate)

        if (column == 'statusupdatedate' || column == 'statusduration' || column == 'interactions' || column == 'inactivedays' || column == 'lastcontacted' || column == 'dayinstage') {
            let params_for_sort = {
                filterdata: this.state.filterdata,
                list: {
                    limit: this.state.pageSize,
                    pageno: this.state.currentPage + 1,
                    searchtext: this.state.searchText,
                    sorttype: direction,
                    type: "sort",
                    fieldId: 0,
                    columnname: column,
                    islimited: true
                },
                piplineid: parseFloat(this.state.selectedPipelineId),
                filterid: 1
            }
            this.getListing(params_for_sort);
            this.setState({ fieldId: 0, column_name: column });
        } else if (this.state.column_ids[column]) {
            let params_for_sort = {
                filterdata: this.state.filterdata,
                list: {
                    limit: this.state.pageSize,
                    pageno: this.state.currentPage + 1,
                    searchtext: this.state.searchText,
                    sorttype: direction,
                    type: "sort",
                    fieldId: this.state.column_ids[column],
                    columnname: column,
                    islimited: true

                },
                piplineid: parseFloat(this.state.selectedPipelineId),
                filterid: 1
            }
            this.getListing(params_for_sort);
            this.setState({ fieldId: this.state.column_ids[column], column_name: column });
        }
        let columnWidths = this.state.columnWidths;
        let IsSizeDefault;
        columnWidths.map((NameSize) => {
            if (NameSize.columnName === 'name' && NameSize.width !== 250) { IsSizeDefault = false } else { IsSizeDefault = true }
        });
        this.setState({ IsSizeDefault: IsSizeDefault });
    }

    changeSearching1 = (e) => {
        let params_for_search = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: e.target.value,
                sorttype: this.state.sorttype,
                type: "search",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(this.state.selectedPipelineId),
            filterid: 1
        }
        this.getListing(params_for_search);
        this.setState({ searchText: e.target.value });
    }


    handleOpportunityDialogClose = () => {
        this.setState({ shouldOpenCreateOpportunityDialog: false, FullCreateOpportunityDialog: false, minimizeOpportunityDialog: false });
    };
    handleOpportunityDialogMinimize = () => {
        this.setState(oldStateminimizeOpportunityDialog => ({ minimizeOpportunityDialog: !oldStateminimizeOpportunityDialog.minimizeOpportunityDialog }));
        this.setState({ FullCreateOpportunityDialog: false })
    };
    handleLeadDialogFull = () => {
        this.setState(oldStateFullCreateOpportunityDialog => ({ FullCreateOpportunityDialog: !oldStateFullCreateOpportunityDialog.FullCreateOpportunityDialog }));
        this.setState({ minimizeOpportunityDialog: false })

    };
    setSelection = (val) => {
        let selectedIds = [];

        if (this.props.opportunityReducer.opportunityList.data.data) {
            let list_data = this.props.opportunityReducer.opportunityList.data.data;
            val.map((key) => {
                if(list_data[key])
                selectedIds.push(parseFloat(list_data[key].opportunities_id));
            });
        }
        this.setState({
            selection: val,
            deleteIds: selectedIds,
            SelectedComapnyID: selectedIds
        });
    }
    handleDrawerRight = (opportunities_id) => {

        if (this.state.opportunities_id && (this.state.opportunities_id === opportunities_id)) { } else {
            this.setState({
                opportunities_id: opportunities_id,
                isDataLoading: true,
            }, () => {
                this.forceUpdate()
            })
        }

        setTimeout(() => {
            this.setState({
                drawerOpen: true,
            }, () => {
                this.forceUpdate()
            })
        }, 2000);

    };
    closeDrawerRight = (e) => {
        // e.preventDefault()
        this.setState({ drawerOpen: false });
    };
    handleDeleteOpportunities = () => {
        this.toggleDeleteDialog()
    }

    toggleDeleteDialog = () => {
        this.setState({ isDeleteConfirmDialoOpen: !this.state.isDeleteConfirmDialoOpen });
    };
    confirmDeleteCustomField = () => {
        let deleteOpportunitiesParams = [];
        deleteOpportunitiesParams['deleteid'] = {
            opportunitiesid: this.state.deleteIds,
            piplineid: parseFloat(this.state.selectedPipelineId),
        };
        deleteOpportunitiesParams['listval'] = {
            filterdata: this.state.filterdata,
            list: {
                limit: this.state.pageSize,
                pageno: 1,
                searchtext: this.state.searchText,
                sorttype: this.state.sorttype,
                type: "list",
                fieldId: this.state.fieldId,
                columnname: this.state.column_name,
                islimited: true
            },
            piplineid: parseFloat(this.state.selectedPipelineId),
            filterid: 1
        };

        this.props.deleteOpportunities(this.props.apolloClient.client, deleteOpportunitiesParams);
        this.setState({
            selection: [],
            deleteIds: []
        });
        this.toggleDeleteDialog()
    };

    handleFollowedCheckbox = (val, name) => {
        // console.log("name1", name);
        // console.log("val1", val);
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })

    }
    handleChangeFilter = (val, name) => {
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 3000);
        })
    };

    rangeClick = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "range", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }
    rangeFilter = (rval, rname) => {
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({ filterRangeArray })
    }

    rangeClickDate = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "date", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }

    rangeFilterDate = (rval, rname) => {
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({
            filterRangeArray
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                this.rangeClickDate(rname, rval.fieldid)
            }, 100);
        })
    }
    handleToggleFieldDisplay = (name) => {
        var exists = this.state.fieldDisplay.includes(name);
        var joined = [];
        let filterRangeArray = this.state.filterRangeArray;

        if (exists) {
            joined = this.state.fieldDisplay.filter((item) => item != name)
            if (filterRangeArray[name]) {
                //delete filterRangeArray[name];
            }
        } else {
            joined = this.state.fieldDisplay.concat(name);
            if (!filterRangeArray[name]) {
                filterRangeArray[name] = ["", ""];
            }
        }

        this.setState({ fieldDisplay: joined, filterRangeArray })
    }

    dropdownMenu = (fkey) => {
        var exists = this.state.dropdownhide.includes(fkey);
        var joined = [];
        if (exists) {
            joined = this.state.dropdownhide.filter((item) => item != fkey)
        } else {
            joined = this.state.dropdownhide.concat(fkey);
        }
        this.setState({ dropdownhide: joined })
    }

    handleFilterSubmit = () => {
        var allowToFilter = true
        let copyObj = JSON.parse(JSON.stringify(this.state.filterObject));
        var filterValuesArray = Object.keys(copyObj);
        var finalFilterData = filterValuesArray.map((k, i) => {
            let v = copyObj[k];

            if (v.value.length > 0) {
                var valuesArray = [];
                v.value.map((val, k) => {
                    if (v.type === "date") {
                        if (val == "Invalid Date") {
                            allowToFilter = false
                        } else if (val == "") {
                            valuesArray.push(val)
                        } else if (val == null) {
                            valuesArray.push("")
                        } else if (val != null) {
                            if (v.fieldid != "0") {
                                val = moment(val).format('YYYY-MM-DD');
                            } else {
                                //val = moment(val).format("X");
                                val = moment(val).format('MM/DD/YYYY');
                            }
                            valuesArray.push(val)
                        }
                    } else if (v.type == "log") {
                        valuesArray.push(val.id);
                    } else if (v.fieldid == '46' && val.email) {
                        valuesArray.push(val.email)
                    } else if (v.fieldid != '46' && val.name) {
                        valuesArray.push(val.name)
                    } else if (val.optionvalue) {
                        valuesArray.push(val.optionvalue)
                    } else if (v.fieldid === "56" || v.type === "range") {//tag array and value
                        valuesArray.push(val);
                    } else {
                        valuesArray.push(val);
                    }
                })


                let checkBoxKey = -1
                if (this.state.fieldsList != undefined) {
                    checkBoxKey = this.findWithAttr(this.state.fieldsList, 'id', v.fieldid);
                }



                v.value = valuesArray;
                if (v.type == "followed") {//follow/not follow filter only value is true
                    if (v.value[0] === true) {
                        return v
                    }
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3" && v.value[0] == "1") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id != "3") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3") {
                } else {
                    return v
                }
            }
        })

        //filter null and undefined object 
        finalFilterData = finalFilterData.filter(function (element) {
            return element !== undefined || (element !== undefined && element.value.length != 0);
        });
        // console.log("allowToFilter", allowToFilter);
        // console.log("finalFilterData", finalFilterData);
        if (allowToFilter) {
            //saveFilter Data for save in future use.
            this.setState({
                filterdata: finalFilterData,
                isDataLoading: true,
            })

            // console.log("this.state.selectedPipelineId", this.state.selectedPipelineId);
            let val = {
                filterdata: finalFilterData,
                list: {
                    limit: this.state.pageSize,
                    pageno: 1,
                    searchtext: this.state.searchText,
                    sorttype: this.state.sorttype,
                    type: "list",
                    fieldId: this.state.fieldId,
                    columnname: this.state.column_name,
                    islimited: true
                },
                piplineid: parseFloat(this.state.selectedPipelineId),
                filterid: 1
            }
            this.getListing(val)
        }
    }

    handleSavefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        if (this.state.filterdata && this.state.filterdata.length > 0) {
            let req = {
                filterdata: this.state.filterdata,
                fitertype: this.state.fitertype,
                filtername: this.state.filtername,
                recordtypeid: this.state.recordtypeid,
            }

            this.props.saveFilterDetailOpportunity(this.props.apolloClient.client, req);
            this.handleSavefilterDialogeClose()
            this.setState({
                displaySelectedFilterName: this.state.filtername,
                newSavedFilterName: this.state.filtername,
            })
        } else {
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
        }
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 2000);
    }
    updateOpportunityFilter = (data) => {
        // console.log("data", data);
        this.setState({
            filterSaveDialoge: true,
            filterUpdateId: data.id,
            filtername: data.filtername,
            fitertype: data.fitertype.toString(),
            oldFilterOption: data.filteroption,
        })
    }
    handleUpdatefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        let req = {
            filterdata: this.state.oldFilterOption,
            fitertype: this.state.fitertype,
            filtername: this.state.filtername,
            filterid: parseInt(this.state.filterUpdateId),
        }
        //return
        this.props.updateFilterDetailOpportunity(this.props.apolloClient.client, req);
        let updateDataInState = this.findWithAttr(this.state.opportunityFilterListArray, 'id', this.state.filterUpdateId);
        if (updateDataInState !== -1) {
            this.state.opportunityFilterListArray[updateDataInState].filtername = this.state.filtername;
            this.state.opportunityFilterListArray[updateDataInState].fitertype = this.state.fitertype;
        }
        this.handleSavefilterDialogeClose()
    }
    updateFilterOptions = () => {
        let key = this.findWithAttr(this.props.opportunityReducer.opportunityFilterListArray.data, 'id', localStorage.getItem('selected_opportunity_filter_id'));
        var data = ""
        if (key !== -1) {
            data = this.props.opportunityReducer.opportunityFilterListArray.data[key];
            if (this.state.filterdata && this.state.filterdata.length > 0) {
                let req = {
                    filterdata: this.state.filterdata,
                    fitertype: data.fitertype.toString(),
                    filtername: data.filtername,
                    filterid: parseInt(data.id),
                }
                this.props.updateFilterDetailOpportunity(this.props.apolloClient.client, req);
                this.handleSavefilterDialogeClose()
            } else {
                //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
            }
            setTimeout(() => {
                this.setState({
                    allowStateUpdateFilter: true,
                })
            }, 1500);
        }
    }
    confirmDeleteFilter = () => {
        this.props.deleteFilterOpportunity(this.props.apolloClient.client, parseInt(this.state.filterDeleteId));
        let removeFilterObjKey = this.findWithAttr(this.props.opportunityReducer.opportunityFilterListArray.data, 'id', this.state.filterDeleteId);
        if (removeFilterObjKey !== -1) {
            if (!this.props.opportunityReducer.opportunityFilterListArray.data[removeFilterObjKey].isdefault == true) {
                this.props.opportunityReducer.opportunityFilterListArray.data.splice(removeFilterObjKey, 1);
            }
        }
        this.filterRemoveDialoge()
    }
    filterRemoveDialoge = () => {
        this.setState({ isDeleteFilter: false, filterDeleteId: "", allowStateUpdateFilter: true })
    }
    handleSavefilterDialoge = () => {
        this.setState({ filterSaveDialoge: true })
    }
    handleSavefilterDialogeClose = () => {
        this.setState({
            filterSaveDialoge: false,
            filternameError: false,
            fitertype: "1",
            filterUpdateId: "",
            oldFilterOption: "",
            filtername: "",
        })
    }

    updateFilterDefaultOpportunity = (data) => {
        this.props.updateFilterDefaultOpportunity(this.props.apolloClient.client, parseInt(data.id));
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 2000);
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    handleFilterChange = (filterdata) => {

        //my open oppoertunity
        if (filterdata.id == "12") {
            let udata = JSON.parse(localStorage.getItem('user_data_session'))
            filterdata.filteroption = [
                {
                    fieldid: "46", name: "owner", type: "value", value: [udata.email]
                },
                {
                    fieldid: "45", name: "status", type: "value", value: ["Open"]
                }
            ]
        }

        //Opportunities Im Following
        if (filterdata.id == "14") {
            filterdata.filteroption = [
                {
                    fieldid: "0",
                    name: "followed",
                    type: "followed",
                    value: [true],
                    chktype: "follow",
                }
            ]
        }

        //won opportunity
        if (filterdata.id == "15") {
            let udata = JSON.parse(localStorage.getItem('user_data_session'))
            filterdata.filteroption = [
                {
                    fieldid: "45", name: "status", type: "value", value: ["Won"]
                }
            ]
        }
        //Open opportunity
        if (filterdata.id == "13") {
            let udata = JSON.parse(localStorage.getItem('user_data_session'))
            filterdata.filteroption = [
                {
                    fieldid: "45", name: "status", type: "value", value: ["Open"]
                }
            ]
        }

        this.setState({
            filterObject: {},
            filterRangeArray: [],
            fieldDisplay: [],
            dropdownhide: [],
        }, () => {
            this.forceUpdate()
            this.setState({ displaySelectedFilterName: filterdata.filtername, currentPage: 0 })
            if (filterdata.filteroption.length > 0) {
                let filterObject = this.state.filterObject;
                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    filterdata.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }
                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }

                        if (val.type == "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }

                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    this.handleFilterSubmit();
                    localStorage.setItem('selected_opportunity_filter_id', filterdata.id)
                });
            } else {
                let val = {
                    filterdata: [],
                    list: {
                        limit: this.state.pageSize,
                        pageno: 1,
                        searchtext: this.state.searchText,
                        sorttype: this.state.sorttype,
                        type: "list",
                        fieldId: this.state.fieldId,
                        columnname: this.state.column_name,
                        islimited: true
                    },
                    piplineid: parseFloat(this.state.selectedPipelineId),
                    filterid: 1
                }
                localStorage.setItem('selected_opportunity_filter_id', filterdata.id)
                this.handleFilterSubmit();
            }
        })

    }

    handlechangeActivityQuery = (event) => {
        this.setState({
            activityquery: event.target.value
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject['activitytype'] && this.state.filterObject['activitytype'].value.length > 0) {
                    this.state.filterObject['activitytype'].query = event.target.value;
                    this.handleFilterSubmit();
                }
            }, 1500);
        })
    }
    handlechangeTagsQuery = (event) => {
        this.setState({
            tagsquery: event.target.value
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject['tags'] && this.state.filterObject['tags'].value.length > 0) {
                    this.state.filterObject['tags'].query = event.target.value;
                    this.handleFilterSubmit();
                }
            }, 1500);
        })
    }
    handleClearFilterData = () => {
        this.setState({
            fieldDisplay: [],
            filterRangeArray: [],
            dropdownhide: [],
            filterObject: {},
            filterdata: [],
            activityquery: "any",
            tagsquery: "any",
        }, () => {
            setTimeout(() => {
                // if(this.state.filterObject['tags'] && this.state.filterObject['tags'].value.length > 0){
                //     this.state.filterObject['tags'].query = event.target.value;
                //     this.handleFilterSubmit();
                // }
            }, 1500);
        })
    }

    handlePipeLineChange = (pipelineData) => {
        // console.log("pipelineData", pipelineData);
        if (this.state.selectedPipelineId != pipelineData.id) {
            localStorage.setItem('selected_pipeline_id', pipelineData.id);
            this.setState({
                selectedPipelineId: pipelineData.id,
                isDataLoading: true,
            }, () => {
                this.getUserPermission()
            });
            let val = {
                filterdata: this.state.filterdata,
                list: {
                    limit: 10,
                    pageno: 1,
                    searchtext: '',
                    sorttype: '',
                    type: "list",
                    fieldId: 1,
                    columnname: "",
                    islimited: true
                },
                piplineid: parseFloat(pipelineData.id),
                filterid: 1
            }
            this.getListing(val)
            this.props.getPipelines(this.props.apolloClient.client);
        }

    };

    handlePipelineADDDialogClose = () => {
        this.setState({ shouldOpenNewPipelineDialog: false, FullNewPipelineDialog: false, minimizePipelineDialog: false, editPiplineData: '', });
    };
    handlePipelineADDDialogMinimize = () => {
        this.setState(oldStateminimizePipelineDialog => ({ minimizePipelineDialog: !oldStateminimizePipelineDialog.minimizePipelineDialog }));
        this.setState({ FullNewPipelineDialog: false })
    };
    handlePipelineADDDialogFull = () => {
        this.setState(oldStateFullNewPipelineDialog => ({ FullNewPipelineDialog: !oldStateFullNewPipelineDialog.FullNewPipelineDialog }));
        this.setState({ minimizePipelineDialog: false })

    }

    toggleReplayMultupleEmail = (emails) => {
        // console.log("data", emails)
        this.setState({
            isOpenedReplayBulkEmail: !this.state.isOpenedReplayBulkEmail,
            userSelectedBlukEmail: this.state.relatedemails,
            mainUserData: { email: '' },
            // leadid: data.lead_id
        });
    }
    toggleReplayBulkEmailclose = () => {
        this.setState({
            isOpenedReplayBulkEmail: !this.state.isOpenedReplayBulkEmail,
        });
    }

    handleSendEmail = (event) => {
        let mailboxid = this.state.mailboxid + Server.BCCINBOX;
        
        let main_email = this.state.allSettings;
        let req = {
            id: this.state.SelectedComapnyID,
            type: 'contact',
            recordtype: 'opportunities'
        }
        this.props.getRelatedContactsData(this.props.apolloClient.client, req);
        this.setState({ isDataLoading: true });
        setTimeout(() => {
            if (main_email.setting_one === 1) {
                this.toggleReplayMultupleEmail();
            } else if (main_email.setting_one === 2) {
                window.open("https://mail.google.com/mail/?view=cm&fs=1&to=" + this.state.relatedemails && this.state.relatedemails.toString() + "&bcc=" + mailboxid, '__blank');
            } else {
                window.open("https://mail.google.com/mail/?view=cm&fs=1&to=" + this.state.relatedemails && this.state.relatedemails.toString(), '__blank');
            }
            this.setState({
                selection: [],
                SelectedComapnyID: []
            });
        }, 4000);
    }

    render() {
        let { isOpenedFiltersDefault, leadLogs, defaultColumnOrder, pageSize, currentPage, totalCount, opportunityListData, isOpenedPipelines, isOpenedFilters, isOpenedRange, shouldOpenCreateOpportunityDialog, minimizeOpportunityDialog, FullCreateOpportunityDialog, drawerOpen } = this.state;

        const tableColumnExtensions = [
            { columnName: 'name', width: 250 },

        ];
        const columns = this.state.columns_array;
        const defaultHiddenColumnNames = this.state.defaultHiddenColumnNames;
        const tableColumnVisibilityColumnExtensions = [
            { columnName: 'name', togglingEnabled: false },
        ];
        const leftColumns = [TableSelection.COLUMN_TYPE, 'name',];

        var localStorageFilter = localStorage.getItem('selected_opportunity_filter_id');
        let updateSaveFilterBtnDisabled = (this.state.filterdata == undefined || !this.state.filterdata.length) ? ((this.state.oldFilterOption == undefined || !this.state.oldFilterOption.length) ? true : false) : false

        const toolbarTemplate = (params) => {
            let { switchView, searchText, pageSize, currentPage, totalCount, opportunityListData, isOpenedPipelines, isOpenedFilters, isOpenedRange, shouldOpenCreateOpportunityDialog, minimizeOpportunityDialog, FullCreateOpportunityDialog, drawerOpen } = this.state;
            return (
                <div className="d-flex list_table_header">
                    <MaterialGrid container justify="space-between">
                        <MaterialGrid>
                            <MaterialGrid container justify="space-between">
                                <MaterialGrid>
                                    <h3 className="ml-16">Opportunities</h3>
                                </MaterialGrid>
                                <MaterialGrid item>
                                    <FormControlLabel
                                        value="cardview"
                                        control={<Switch color="primary" checked={switchView} name="switchView" onChange={this.handleChange} value="switchView" />}
                                        label="Listview"
                                        labelPlacement="start"
                                    />
                                </MaterialGrid>
                                {this.state.selection.length ?
                                    <MaterialGrid className="flex flex-middle ml-10">
                                        {this.state.selection.length}  selected
                                        <IconButton onClick={this.handleSendEmail} aria-label="Email" size="small" className="ml-8">
                                            <Icon>email</Icon>
                                        </IconButton>
                                        {/* <IconButton aria-label="Edit" size="small" className="ml-8">
                                        <Icon>edit</Icon>
                                    </IconButton> */}
                                        {this.state.crudPermission.isdelete &&
                                            <IconButton aria-label="Delete" size="small" onClick={() => this.handleDeleteOpportunities()} className="ml-8">
                                                <Icon>delete</Icon>
                                            </IconButton>
                                        }
                                        <DropdownDefault
                                            menuButton={
                                                <IconButton size="small" className="ml-8">
                                                    <Icon>more_vert</Icon>
                                                </IconButton>
                                            }
                                        >
                                            {/* <MenuItem className="flex flex-middle">
                                                <Icon className="mr-16">call_merge</Icon> Merge leads
                                            </MenuItem> */}
                                            <MenuItem className="flex flex-middle">
                                                <Icon className="mr-16">file_download</Icon> Export List
                                            </MenuItem>
                                        </DropdownDefault>
                                    </MaterialGrid>
                                    :
                                    ''
                                }
                            </MaterialGrid>
                        </MaterialGrid>
                        <MaterialGrid>
                        </MaterialGrid>
                    </MaterialGrid>
                    <TextField
                        id="search-input"
                        placeholder="search"
                        defaultValue={searchText}
                        onChange={this.changeSearching1}
                        onKeyDown={this.keyPress}
                        autoFocus={searchText ? true : false}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon>search</Icon>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <HiddenColumns allData={this} columns={columns} />
                    {params.children}
                    <div className="d-inline-block ml-8 mr-8">
                        <DropdownDefault
                            menuButton={
                                <Button variant="contained" color="primary" className="btn_Primary" size="small">
                                    Actions
                            </Button>
                            }
                        >
                            <Link to={'/settings/settings'}>
                                <MenuItem className="flex flex-middle">
                                    <Icon className="mr-16">format_list_numbered</Icon> Create custom fileds
                            </MenuItem>
                            </Link>
                        </DropdownDefault>
                    </div>
                    {/* <div className="d-inline-block ml-8">
                        <Button variant="contained" size="small">
                            Import
                            </Button>
                    </div> */}
                    {this.state.crudPermission.iscreate &&
                        <div className="d-inline-block ml-8 mr-16">
                            <Button variant="contained" color="secondary" onClick={() => this.setState({ shouldOpenCreateOpportunityDialog: true })} size="small" style={{ minWidth: 95 }}>
                                Create New
                            </Button>
                        </div>
                    }
                </div>
            );
        };



        return (
            <div className="opportunities_card progression-report">
                <aside className="aside_left" style={{ overflowY: 'scroll', overflow: 'auto' }}>
                    <Card elevation={3}>
                        <h5 onClick={this.toggleLeadList} className="cursor_poiter d-flex justify-content-between">Pipelines <Icon className="vert-middle flex-end">{isOpenedPipelines ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon></h5>
                        {isOpenedPipelines &&
                            <div className="filter_menu">
                                <ul>
                                    {this.state.isLoadingPipelineList && <li className="text-center"><CircularProgress size={20} /></li>}
                                    {this.state.pipelineListArray.length > 0
                                        && this.state.pipelineListArray.map((item, key) =>
                                            this.state.disableID !== item.id &&
                                            <li onClick={() => this.handlePipeLineChange(item)}>
                                                <Link className={(this.state.selectedPipelineId == item.id) ? "pipline-selected-class" : ""}>{item.name}
                                                </Link>
                                            </li>
                                        )}
                                    {
                                        this.props.authReducer.userRole.id !== 3 &&
                                        <li>
                                            <Link onClick={() => this.setState({ shouldOpenNewPipelineDialog: true })}>
                                                + Create New Pipeline
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }

                        <Link to="/opportunities/progression-report"><h5 className="cursor_poiter">Reports</h5></Link>
                        <h5 onClick={this.toggleFiltersDefault} className="cursor_poiter d-flex justify-content-between">Filters 
                        <TooltipNew title={this.state.displaySelectedFilterName}>
                                <div className="font-weight-400">
                                    <div className="text_ellipsis" style={{ maxWidth: '118px', fontSize: '13px' }}>
                                        ({this.state.displaySelectedFilterName})
                                    </div>
                                    <span style={{fontSize: '13px'}} > ({totalCount})</span>
                                </div>
                            </TooltipNew>
                                <Icon className="vert-middle flex-end">{isOpenedFiltersDefault ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon></h5>{isOpenedFiltersDefault &&
                                <div className="filter_menu_custom">
                                    <h6 className="mt-8 font-size-14 mb-0 pl-16 pr-16">Private Filters </h6>
                                    <ul>
                                        {this.state.opportunityFilterListArray.length > 0 && this.state.opportunityFilterListArray.map((item, key) => {
                                            let star_icon = item.isdefault ? "star" : "star_border";
                                            if (item.fitertype == 1 && item.id != localStorage.getItem('selected_opportunity_filter_id')) {
                                                return <li key={item.key}>
                                                    <div onClick={() => this.handleFilterChange(item)}>{item.filtername}</div>
                                                    <><IconButton className="text-secondary ml-4" size="small">
                                                        <Icon onClick={() => this.updateOpportunityFilter(item)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'settings'}</Icon>
                                                    </IconButton>
                                                        <IconButton className="text-secondary ml-4" size="small">
                                                            <Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: item.id })} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'delete'}</Icon>
                                                        </IconButton>
                                                        <IconButton className="text-secondary ml-4" size="small">
                                                            <Icon onClick={() => this.updateFilterDefaultOpportunity(item)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{star_icon}</Icon>
                                                        </IconButton>
                                                    </>
                                                </li>
                                            }
                                        }
                                        )}
                                    </ul>
                                    <h6 className="mt-8 font-size-14 mb-0 mt-16 pl-16 pr-16">Public Filters</h6>
                                    <ul>
                                        {this.state.opportunityFilterListArray.length > 0 && this.state.opportunityFilterListArray.map((items, key) => {
                                            let star_icon = items.isdefault ? "star" : "star_border";
                                            if (items.fitertype == 0 && items.id != localStorage.getItem('selected_opportunity_filter_id')) {
                                                return <li key={items.key}>
                                                    <div onClick={() => this.handleFilterChange(items)}>{items.filtername}</div>
                                                    {!["11", "12", "13", "14", "15"].includes(items.id) &&
                                                        <><IconButton className="text-secondary ml-4" size="small">
                                                            <Icon onClick={() => this.updateOpportunityFilter(items)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'settings'}</Icon>
                                                        </IconButton>
                                                            <IconButton className="text-secondary ml-4" size="small">
                                                                <Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: items.id })} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{'delete'}</Icon>
                                                            </IconButton></>
                                                    }
                                                    <IconButton className="text-secondary ml-4" size="small">
                                                        <Icon onClick={() => this.updateFilterDefaultOpportunity(items)} style={{ marginTop: '5px', display: 'contents', fontSize: '18px' }}>{star_icon}</Icon>
                                                    </IconButton>
                                                </li>
                                            }
                                        }
                                        )}
                                    </ul>

                                    <><Dialog
                                        fullWidth={true}
                                        maxWidth={'xs'}
                                        open={this.state.isDeleteFilter}
                                        onClose={this.filterRemoveDialoge}
                                        disableBackdropClick

                                        aria-labelledby="ar-remove-dialog-title"
                                    >
                                        <DialogTitle id="ar-remove-dialog-title">{"Are you sure you want to delete filter ?"}</DialogTitle>
                                        <DialogActions>
                                            <Button onClick={this.filterRemoveDialoge} color="primary">Cancel</Button>
                                            <Button type="Button" onClick={() => this.confirmDeleteFilter()} className="btn_Primary">
                                                Ok
                                    </Button>
                                        </DialogActions>
                                    </Dialog></>
                                </div>
                        }
                    </Card>
                    <Card elevation={3} className={`pt-16 pb-16`} style={{ marginTop: '5px' }}>
                        <div className="ml-16 mr-16">
                            <Button fullWidth className="btn_Primary" size="small" onClick={this.toggleCustomFilters}><Icon>add</Icon> Add Custom Filters</Button>
                        </div>
                        {isOpenedFilters &&
                            <React.Fragment>
                                <div className="v_scroll position-relative ml-16 mt-16 pr-16">
                                    <Link className="text_link" onClick={() => this.handleFilterChange(this.state.opportunityFilterListArray[this.state.AllOpportunityFilterKey])}>Clear All</Link>
                                    {FilterComponent(this)}
                                </div>
                                <div className="fixed-bottom" style={{ position: 'initial' }}>
                                    <Button type="button" className="btn_Primary  mb-16 px-12" size="small" onClick={() => this.handleSavefilterDialoge()}>Save Filter</Button>
                                    {localStorageFilter && !["11", "12", "13", "14", "15"].includes(localStorageFilter) &&
                                        <Button type="button" className="btn_Primary  mb-16 px-12 ml-16" size="small" onClick={() => this.updateFilterOptions()}>Update Filter</Button>
                                    }
                                </div>
                            </React.Fragment>
                        }
                    </Card>
                </aside>
                <Card elevation={3} className="fixed_layout">
                    <div className="leads_list_table">
                        <Grid rows={opportunityListData} columns={columns}>
                            <SelectionState
                                selection={this.state.selection}
                                onSelectionChange={this.setSelection}
                            />
                            <IntegratedSelection />
                            <VirtualTable />
                            {/* <SearchState defaultValue="" onValueChange={((val) => { this.changeSearching(val) })} /> */}
                            <IntegratedFiltering />
                            <SortingState
                                defaultSorting={this.state.defaulSortingData}
                                onSortingChange={(val => { this.changeDefaultSorting(val) })}
                                sorting={this.state.defaulSortingData}
                            />
                            {/* <IntegratedSorting /> */}
                            <DragDropProvider />
                            <PagingState
                                currentPage={currentPage}
                                pageSize={pageSize}
                                //defaultCurrentPage={defaultCurrentpage}
                                onCurrentPageChange={(page) => this.handleCurrentPage(page)}
                                onPageSizeChange={(size) => this.handlePageSize(size)}

                            />
                            <Table columnExtensions={tableColumnExtensions}
                                noDataCellComponent={() => <LoadingState componetname="Opportunity" icon="business" columnCount={columns.length} loading={this.state.isDataLoading} />} />

                            <TableColumnResizing
                                defaultColumnWidths={this.state.columnWidths}
                                onColumnWidthsChange={this.onColumnWidthsChange}
                            />
                            <TableSelection showSelectAll highlightRow />
                            <TableColumnReordering
                                defaultOrder={defaultColumnOrder}
                                order={defaultColumnOrder}
                                onOrderChange={(val) => { this.handleChangeColumnOrder(val) }}
                            />
                            <TableHeaderRow showSortingControls />
                            <PagingPanel
                                // pageSizes={[2, 5, 10, 15]}
                                pageSizes={[10, 25, 50, 100]}
                            />
                            <CustomPaging
                                totalCount={totalCount}
                            />
                            <TableFixedColumns
                                leftColumns={leftColumns}
                            />
                            <TableColumnVisibility
                                defaultHiddenColumnNames={defaultHiddenColumnNames}
                                hiddenColumnNames={defaultHiddenColumnNames}
                                columnExtensions={tableColumnVisibilityColumnExtensions}
                                onHiddenColumnNamesChange={(val) => { this.handleChangeColumnHidden(val) }}
                            />
                            <Toolbar rootComponent={toolbarTemplate} />
                            {/* <SearchPanel  /> */}
                            {/* <ColumnChooser /> */}
                        </Grid>
                    </div>
                </Card>
                <Drawer
                    width={"100px"}
                    variant="temporary"
                    anchor={"right"}
                    className="drawer_right"
                    open={drawerOpen}
                    onClose={this.closeDrawerRight}
                    ModalProps={{
                        keepMounted: true
                    }}
                >
                    <OpportunityProfileFrame opportunities_id={this.state.opportunities_id} opportunityLogs={this.state.opportunityLogs} handleClose={this.closeDrawerRight} />
                </Drawer>
                {shouldOpenCreateOpportunityDialog && (
                    <CreateNewOpportunityDialog
                        handleClose={this.handleOpportunityDialogClose}
                        open={shouldOpenCreateOpportunityDialog}
                        handleMinimize={this.handleOpportunityDialogMinimize}
                        handleFull={this.handleLeadDialogFull}
                        minimizeScreen={minimizeOpportunityDialog}
                        fullScreen={FullCreateOpportunityDialog}
                    />
                )}
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.isDeleteConfirmDialoOpen}
                    onClose={this.toggleDeleteDialog}
                    disableBackdropClick

                    aria-labelledby="ar-remove-dialog-title"
                >
                    <DialogTitle id="ar-remove-dialog-title">{"Are you sure you want to remove selected Opportunity ?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.toggleDeleteDialog} color="primary">
                            Cancel
                                      </Button>
                        <Button type="Button" onClick={() => this.confirmDeleteCustomField()} className="btn_Primary">
                            Ok
                                      </Button>

                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.filterSaveDialoge}
                    onClose={() => this.handleSavefilterDialogeClose()}
                    disableBackdropClick

                    aria-labelledby="delele-dialog-title"
                >
                    <DialogTitle id="">
                        {!this.state.filterUpdateId ? "Add a New Filter" : "Edit Filter"}
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <ValidatorForm instantValidate={false} ref="form">
                            <FormControl error={this.state.filternameError} className="w-100 input_bx">
                                <InputLabel htmlFor="component-error">Name</InputLabel>
                                <Input
                                    type="text"
                                    id={'filtername'}
                                    label={'Filter Name'}
                                    className="w-100 input_bx"
                                    onChange={(event) => this.handleChange(event)}
                                    name={'filtername'}
                                    value={this.state.filtername}
                                />
                                {this.state.filternameError && <FormHelperText id="component-error-text">This field is required</FormHelperText>}
                            </FormControl>
                            <br /><br />
                            <div>
                                <span>visibility</span>
                                <br />
                                <RadioGroup name="fitertype" value={this.state.fitertype} onChange={(event) => this.handleChange(event)} row>
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio color="primary" />}
                                        label="Private"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio color="primary" />}
                                        label="Public"
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </div>

                        </ValidatorForm>
                    </DialogContent>
                    <DialogActions>
                        {updateSaveFilterBtnDisabled && <p className="lead-filter-error">Please select filter options to save filter</p>}
                        <Button onClick={() => this.handleSavefilterDialogeClose()} color="primary">
                            Cancel
                        </Button>
                        {!this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" color="primary" onClick={() => this.handleSavefilter()}>Save</Button>}
                        {this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" color="primary" onClick={() => this.handleUpdatefilter()}>Update</Button>}
                    </DialogActions>
                </Dialog>

                {this.state.shouldOpenNewPipelineDialog && (
                    <AddNewPipeline
                        handleClose={this.handlePipelineADDDialogClose}
                        open={this.state.shouldOpenNewPipelineDialog}
                        handleMinimize={this.handlePipelineADDDialogMinimize}
                        handleFull={this.handlePipelineADDDialogFull}
                        minimizeScreen={this.state.minimizePipelineDialog}
                        fullScreen={this.state.FullNewPipelineDialog}
                    />
                )}
                {this.state.isDataLoading &&
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.isDataLoading}
                        TransitionComponent={Fade}
                        message={<><CircularProgress size={20} style={{ color: 'white' }} /><span style={{ paddingLeft: '6px', color: 'white' }}>{" Loading..."}</span></>}
                        variant={'success'}
                    />
                }
                {this.state.isOpenedReplayBulkEmail &&
                    <InboxComposeMultipleDialog
                        handleClose={this.toggleReplayBulkEmailclose}
                        userSelectedEmail={this.state.userSelectedBlukEmail}
                        open={this.state.isOpenedReplayBulkEmail}
                        mainUserData={this.state.mainUserData}
                        LogDetails={{}}
                        LogComponent="opportunites"
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        opportunityReducer: state.opportunityReducer,
        settingReducer: state.settingReducer,
        apolloClient: state.apolloClient,
        authReducer: state.authReducer
    };
};
const mapDispatchToProps = dispatch => {
    return {
        updateOpportunitiesListColumnOrder: (client, request) => { dispatch(actions.updateOpportunitiesListColumnOrder(client, request)) },
        addFavouriteOpportunities: (client, request) => { dispatch(actions.addFavouriteOpportunities(client, request)) },
        deleteOpportunities: (client, request) => { dispatch(actions.deleteOpportunities(client, request)) },
        getOpportunitiesFilterList: (client, request) => { dispatch(actions.getOpportunitiesFilterList(client, request)) },
        getOpportunitiesListColumnOrder: (client) => { dispatch(actions.getOpportunitiesListColumnOrder(client)) },
        getCityList: (client) => { dispatch(actions.getCityList(client)) },
        getStateList: (client) => { dispatch(actions.getStateList(client)) },
        getZipcodeList: (client) => { dispatch(actions.getZipcodeList(client)) },
        saveFilterDetailOpportunity: (client, request) => { dispatch(actions.saveFilterDetailOpportunity(client, request)) },
        getFilterListOpportunity: (client, recordtypeid) => { dispatch(actions.getFilterListOpportunity(client, recordtypeid)) },
        updateFilterDefaultOpportunity: (client, filterid) => { dispatch(actions.updateFilterDefaultOpportunity(client, filterid)) },
        updateFilterDetailOpportunity: (client, req) => { dispatch(actions.updateFilterDetailOpportunity(client, req)) },
        deleteFilterOpportunity: (client, req) => { dispatch(actions.deleteFilterOpportunity(client, req)) },
        getUserSetting: (client, data) => dispatch(actions.getUserSetting(client, data)),
        getUserList: (client) => dispatch(actions.getUserList(client)),
        getPipelines: (client) => dispatch(actions.getPipelines(client)),
        getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
        getUserIntegration: (client) => dispatch(actions.getUserIntegration(client)),
        getRelatedContactsData: (client, value) => dispatch(actions.getRelatedContactsData(client, value)),
        generateMailBoxId: (client) => { dispatch(actions.generateMailBoxId(client)) },
        getEmailSetting: (client) => dispatch(actions.getEmailSetting(client)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(OpportunitiesList);
